// extracted by mini-css-extract-plugin
export default {"Experience":"experience_Experience__YnfEX","Title":"experience_Title__qAjAn"};